import { dispatchAnalyticsEvent } from "@/utils";
import { Product, Variant } from "@/types/types";

export type PaymentPlansAnalytics = {
  ifcDisclaimerAnalyticsClickHandler: (subtype: string) => void;
  ibcDisclaimerAnalyticsClickHandler: (subtype: string, type: string) => void;
};

type AnalyticsProduct = Pick<
  Product,
  "aliases" | "brand" | "browsePageHierarchy"
>;

export const createPaymentPlansAnalytics = (
  product: AnalyticsProduct,
  variant: Variant,
): PaymentPlansAnalytics => ({
  ifcDisclaimerAnalyticsClickHandler: (subtype) =>
    dispatchAnalyticsEvent(
      "global.interaction",
      { type: "pdp", subType: subtype },
      {
        products: [
          {
            brand: product.brand?.name || "",
            category:
              product.browsePageHierarchy[
                product.browsePageHierarchy.length - 1
              ]?.categoryId,
            sku: variant.aliases.skuId,
            price: variant.price?.value || "",
            productName: variant.title,
            productId: product.aliases.pimProductId,
          },
        ],
      },
    ),
  ibcDisclaimerAnalyticsClickHandler: (subtype, type) =>
    dispatchAnalyticsEvent(
      "global.interaction",
      { type, subType: subtype },
      { products: [], additionalInfo: {}, properties: {} },
    ),
});
